import { fetchData } from "./fetchData";

export const getAllUsersAPI = async (getUserGroups = false) => {
    const route = getUserGroups ? `/admin/users?getGroups=true` : `/admin/users`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}

export const getUserAPI = async (UserID) => {
    const route = `/admin/users/${UserID}`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}

export const updateUserAPI = async (UserID, userData) => {
    const route = `/admin/users/${UserID}`;

    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(userData)
    }

    let response = await fetchData(route, options);

    return response;
}


export const deleteUserAPI = async (UserID) => {
    const route = `/admin/users/${UserID}`;

    const options = {
        method: 'DELETE',
    }

    let response = await fetchData(route, options);

    return response;
}